module.exports = __webpack_public_path__ + "media/images/message_r-feb5b685bfd7a21ec4b930597ae68d5a.png";